import React from "react";
import { STRIPE_LINKS, EVENT } from "@/lib/landingConfig";
import { useReservation } from "@/components/landing/ReservationModal";

/**
 * MobileCTA — Fixed sticky "Reservar plaza" pill visible only on mobile.
 * Opens the ActiveCampaign reservation modal for the General Pass when
 * available; otherwise anchors down to the inscription section (waitlist).
 * Auto-hides while user is at the very top or at the very bottom.
 */
const MobileCTA = () => {
  const [visible, setVisible] = React.useState(false);
  const { open: openReservation } = useReservation();

  React.useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      const h = document.documentElement;
      const nearBottom = y + window.innerHeight >= h.scrollHeight - 200;
      setVisible(y > 350 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const generalAvailable = !EVENT.generalBatchClosed;

  const commonClass =
    "pointer-events-auto flex items-center justify-center gap-3 w-full bg-[#63846F] text-[#FAF8F3] py-4 uppercase tracking-[0.22em] text-xs font-medium shadow-[0_10px_30px_-10px_rgba(63,64,58,0.35)]";

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 px-4 pb-4 pt-2 pointer-events-none transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
      data-testid="mobile-cta-wrapper"
    >
      {generalAvailable ? (
        <button
          type="button"
          onClick={() => openReservation(STRIPE_LINKS.general, "Pase General")}
          className={commonClass}
          data-testid="mobile-cta-button"
        >
          Reservar plaza
          <span aria-hidden>→</span>
        </button>
      ) : (
        <a
          href="#inscripcion"
          className={commonClass}
          data-testid="mobile-cta-button"
        >
          Reservar plaza
          <span aria-hidden>→</span>
        </a>
      )}
    </div>
  );
};

export default MobileCTA;
